import React from "react";
import axios from "axios";
import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

import Modal from "./modal";

interface BetaFeedbackModalProps {
  title: string;
  id: string;
  dataBackdrop?: boolean;
  feature: string;
  setUpAxios: any;
}

interface BetaFeedbackModalState {
  notes: string;
  submitting: boolean;
}

export default class BetaFeedbackModal extends React.Component<
  BetaFeedbackModalProps,
  BetaFeedbackModalState
> {
  closeButton: any;

  static defaultProps = {
    dataBackdrop: true,
  };

  state: BetaFeedbackModalState = {
    notes: "",
    submitting: false,
  };

  componentDidMount() {
    this.props.setUpAxios();
  }

  render() {
    return (
      <Modal
        title={this.props.title}
        id={this.props.id}
        dataBackdrop={this.props.dataBackdrop}
      >
        <div className="feedback-form">
          <form>
            <textarea
              className="full-width"
              value={this.state.notes}
              onChange={this.handleChange}
            />
          </form>
        </div>
        <div className="actions">
          <input
            onClick={this.handleSubmit}
            type="submit"
            value={this.getSubmitButtonCopy()}
            className="btn btn-primary"
            disabled={this.state.submitting}
          />
          <a
            ref={(input) => {
              this.closeButton = input;
            }}
            className="cancel"
            data-dismiss="modal"
            href="#"
          >
            {i18n.translate("forms.cancel")}
          </a>
        </div>
      </Modal>
    );
  }

  handleChange = (e: any) => {
    this.setState({
      notes: e.target.value,
    });
  };

  handleSubmit = (e: any) => {
    e.preventDefault();
    this.initiateSubmit();

    const data = {
      beta_feedback: {
        feature: this.props.feature,
        notes: this.state.notes,
        url: window.location.href,
      },
    };
    axios.post("/beta_feedbacks", data).then(() => {
      this.resolveSubmit();
    });
  };

  initiateSubmit = () => {
    this.setState({
      submitting: true,
    });
  };

  resolveSubmit = () => {
    this.handleResetForm();
    this.closeButton.click();
    this.setState({
      submitting: false,
    });
  };

  handleResetForm = () => {
    this.setState({
      notes: "",
    });
  };

  getSubmitButtonCopy = () => {
    return this.state.submitting
      ? i18n.translate("forms.thanks")
      : i18n.translate("forms.submit");
  };
}
